import { CarrierVisitDirection } from '@planning/app/api'
import { ContainerDetailsCard } from '@planning/components/molecules/container/ContainerDetailsCard'
import { ContainerJourneyStatus } from '@planning/components/molecules/ContainerJourneyStatusChip'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { FC } from 'react'
import { RailcarPlanningOrderMenu } from './RailcarPlanningOrderMenu'

export type RailcarPlanningContainerProps = {
  id: number
  number: string
  isoCode: string
  weight?: number
  status: ContainerJourneyStatus
  size?: number | null
  direction?: CarrierVisitDirection

  pod?: string | null
  pol?: string | null
  shippingLine?: string | null
  consignee?: string | null
  referenceNumber?: string | null

  isEmpty?: boolean
  isOog?: boolean
  isDangerous?: boolean
  isReefer?: boolean
  isDamaged?: boolean
  hasHolds?: boolean

  hasIssue?: boolean

  filter?: string | null

  orderItem?: IOrderItem
}

export const RailcarPlanningContainer: FC<RailcarPlanningContainerProps> = props => {
  const { hasHolds, orderItem, filter, number } = props
  const containerNumberMatchesFilter =
    !!filter && number.toLowerCase().includes(filter.toLowerCase())

  return (
    <ContainerDetailsCard
      {...props}
      orderData={orderItem?.data}
      renderActions={
        orderItem && (
          <RailcarPlanningOrderMenu order={orderItem} journey={orderItem.containerJourney} />
        )
      }
      hasHolds={hasHolds}
      isHighlighting={!!filter}
      highlight={containerNumberMatchesFilter}
    />
  )
}
